document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('interstitial-modal');
  if (!modal) return;

  const enterBtn = document.getElementById('enter-site');
  const closeBtn = document.getElementById('close-modal');

  const displayOn = modal.dataset.displayOn || 'all';
  const delay = (parseInt(modal.dataset.delay, 10) || 0) * 1000;
  const frequency = modal.dataset.frequency || 'always';

  const isHome = window.location.pathname === '/' || window.location.pathname === '/index';
  const isMobile = window.innerWidth <= 600;
  const hasShown = localStorage.getItem('interstitialShown');

  // 🏠 Show only on homepage if configured
  if (displayOn === 'home' && !isHome) return;

  // 📱 Desktop/mobile logic
  if (displayOn === 'mobile' && !isMobile) return;
  if (displayOn === 'desktop' && isMobile) return;

  // 🔁 Frequency control
  if (frequency === 'once' && hasShown) return;

  // 🕒 Delay logic
  setTimeout(() => {
    modal.classList.remove('hidden');
    modal.classList.add('flex'); // Ensure it's visible and centered
  }, delay);

  // ✖️ Close / enter actions
  [enterBtn, closeBtn].forEach(btn => {
    if (btn) {
      btn.addEventListener('click', () => {
        modal.classList.add('hidden');
        modal.classList.remove('flex');
        localStorage.setItem('interstitialShown', 'true');
      });
    }
  });
});
